var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2430 4670 c-542 -35 -1087 -313 -1439 -735 -466 -559 -610 -1309 -385 -1995 176 -534 539 -957 1039 -1210 517 -263 1108 -300 1650 -106 116 42 312 137 403 196 l64 41 -140 147 c-77 81 -151 158 -165 171 l-26 23 -104 -51 c-255 -124 -457 -171 -737 -171 -275 0 -508 54 -743 172 -721 361 -1065 1189 -810 1948 173 513 603 913 1123 1045 168 42 267 55 430 55 271 0 509 -56 749 -177 58 -28 110 -49 117 -45 6 4 85 78 174 164 l164 156 -80 51 c-371 239 -817 350 -1284 321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 3783 c-62 -7 -171 -36 -210 -55 -117 -59 -181 -133 -217 -252 -49 -162 7 -313 161 -430 97 -74 190 -122 442 -229 562 -240 708 -345 833 -598 l53 -107 24 92 c22 84 24 109 23 316 0 204 -3 237 -27 351 -88 418 -266 689 -544 828 -135 68 -370 105 -538 84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606 3285 c-283 -616 -298 -1019 -52 -1389 144 -215 343 -360 617 -450 145 -47 238 -59 426 -53 230 6 356 48 461 154 62 61 96 131 113 227 23 135 -10 243 -105 341 -94 96 -205 159 -496 280 -518 216 -701 350 -819 599 -52 108 -63 158 -70 311 l-6 130 -69 -150z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.75bb6adacfb6c19f5528a59e67effb68.svg";
export { ForwardRef as ReactComponent };